import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { formatShortcut } from "@redotech/redo-web/keyboard-shortcuts/keyboard-shortcut";
import { Tooltip } from "@redotech/redo-web/tooltip/tooltip";
import { memo } from "react";
import type {
  useDeleteDraftAction,
  useSendMessageAction,
} from "../actions/use-conversation-actions";

export const MessageInputActions = memo(function MessageInputActions({
  sendAction,
  deleteDraftAction,
  onSend,
  onDeleteDraft,
  isDeletingDraft,
  isSavingDraft,
  isSending,
}: {
  sendAction: ReturnType<typeof useSendMessageAction>;
  deleteDraftAction: ReturnType<typeof useDeleteDraftAction>;
  onSend: () => void;
  onDeleteDraft: () => void;
  isDeletingDraft: boolean;
  isSavingDraft: boolean;
  isSending: boolean;
}) {
  return (
    <>
      {deleteDraftAction?.shortcut ? (
        <Tooltip
          title={`${deleteDraftAction.title} (${formatShortcut(deleteDraftAction.shortcut)})`}
        >
          <RedoButton
            hierarchy="tertiary"
            IconLeading={deleteDraftAction.Icon}
            onClick={onDeleteDraft}
            pending={isDeletingDraft || isSavingDraft}
            size="sm"
            text=""
          />
        </Tooltip>
      ) : (
        <RedoButton
          hierarchy="tertiary"
          IconLeading={deleteDraftAction.Icon}
          onClick={onDeleteDraft}
          pending={isDeletingDraft || isSavingDraft}
          size="sm"
          text=""
        />
      )}
      {sendAction.shortcut ? (
        <Tooltip
          title={`${sendAction.title} (${formatShortcut(sendAction.shortcut)})`}
        >
          <RedoButton
            hierarchy="primary"
            IconLeading={sendAction.Icon}
            onClick={onSend}
            pending={isSending}
            size="md"
            text={sendAction.title}
            theme="normal"
          />
        </Tooltip>
      ) : (
        <RedoButton
          hierarchy="primary"
          IconLeading={sendAction.Icon}
          onClick={onSend}
          pending={isSending}
          size="md"
          text={sendAction.title}
          theme="normal"
        />
      )}
    </>
  );
});
